import { Component, defineComponent } from 'vue';

import {
	SearchFilterContainer,
	AttendanceFilter,
	DegreeTypeFilter,
	DisciplineFilter,
	DurationFilter,
	FormatFilter,
	LocationFilter,
	TuitionFeeFilter,
	SpecialProgrammesFilter,
	SelectedFilters,
} from '@studyportals/search-filters';

export default defineComponent({
	components: {
		SelectedFilters: SelectedFilters as Component,
		SearchFilterContainer: SearchFilterContainer as Component,
		DisciplineFilter: DisciplineFilter as Component,
		LocationFilter: LocationFilter as Component,
		DurationFilter: DurationFilter as Component,
		FormatFilter: FormatFilter as Component,
		AttendanceFilter: AttendanceFilter as Component,
		DegreeTypeFilter: DegreeTypeFilter as Component,
		SpecialProgrammesFilter: SpecialProgrammesFilter as Component,
		TuitionFeeFilter: TuitionFeeFilter as Component,
	},
});
